import React from 'react';
import { Helmet } from 'react-helmet';
import ECommerce from './E_Commerce';

const ECommercePage = () => (
  <>
    <Helmet>
      <title>E-Commerce | MilaajBrandset</title>
      <meta
        name="description"
        content="Boost your online sales with MilaajBrandset's e-commerce solutions designed to enhance your store's performance and customer experience."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, e-commerce solutions, online sales, store optimization, digital retail"
      />
      <meta property="og:title" content="E-Commerce | MilaajBrandset" />
      <meta
        property="og:description"
        content="Boost your online sales with MilaajBrandset's e-commerce solutions designed to enhance your store's performance and customer experience."
      />
    </Helmet>
    <ECommerce />
  </>
);

export default ECommercePage;